import createPersistedState from 'vuex-persistedstate'

/**
 * Persists storage of certain stores in localStorage
 */
export default createPersistedState({
  key: 'PB_STATE',
  paths: ['app', 'session'],
})
